import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/admin/agreements")({
  head: () => ({
    meta: [
      { title: "Agreement review · Landoo Admin" },
      { name: "description", content: "Agreement review — Landoo admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Agreement review" role="Admin" items={ADMIN_NAV}>
      <PlaceholderCard
        title="Agreement review"
        description="Admin queue for Agreement review. Actions and filters will be added here."
      />
    </DashboardShell>
  ),
});
